import errorNoRepLight from "@images/error/errorNoRepLight.svg"
import { word } from "@modules/core/utils/i18n"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

export function ProgramSubscriberDetailsLayoutError({ className, ...props }: React.ComponentProps<"div">) {
  const defaultClassName = "flex flex-column h-30rem min-h-full w-full gap-2 align-items-center justify-content-center"
  const theme = useTheme()
  return (
    <div className={className ?? defaultClassName} {...props}>
      <HUText fontStyle="HS" color={theme.neutralColor900}>
        {word("global.error.norep")}
      </HUText>
      <img src={errorNoRepLight} />
      <HUText fontStyle="HS" color={theme.neutralColor700}>
        {word("global.error.somethingGoneWrong")}
      </HUText>
    </div>
  )
}
